import { Component, OnInit, ViewChild, Input, ElementRef } from "@angular/core";
import { BaseComponent } from "../../Library/BaseComponent";
import { MasterDataService } from "../../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import { PMSService } from "../../Services/PMSService";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { GlitchService } from "../../Services/GlitchService";
import {
    Glitch_UpdateRequest,
    Glitch_SearchRequest,
    GlitchAttachment
} from "../../Models/RequestModels";
import {
    Glitch_RegistrationTypes,
    AuthActionCodes,
    GlitchOperationActions,
    JobPopoverMode,
    EntityCodes,
    VisitorSearchCharLimit
} from "../../Models/EnumModels";
import {
    PropertyBasicInfo,
    LocationLookup,
    GenericMaster,
    GlitchDescription,
    GlitchCategory
} from "../../Models/GlobalEntities";
import { ComplainService } from "../../Services/ComplainService";
import * as alasql from "alasql";
import * as Collections from "typescript-collections";
import { GuestLookup, VisitorLookup } from "../../Models/ResponseModels";
import { untilDestroyed } from "ngx-take-until-destroy";
import { GuestDetail } from "../GuestDetail/GuestDetail";
import { AppSettings } from "../../Library/AppSettings";
import { NgSelectComponent } from "@ng-select/ng-select";
import {
    NgbModal,
    NgbModalRef,
    NgbModalOptions
} from "@ng-bootstrap/ng-bootstrap";
import { debounceTime } from "rxjs/operators";
import { cloneDeep, remove, every, first, find, intersection } from "lodash"

@Component({
    selector: "RegisterGlitch",
    templateUrl: "./RegisterGlitch.html"
})
export class RegisterGlitch extends BaseComponent implements OnInit {
    @ViewChild("guest") guest: GuestDetail;

    @ViewChild("cmbLocations") cmbLocations: NgSelectComponent;
    @ViewChild("cmbGuests") cmbGuests: NgSelectComponent;
    @ViewChild("cmbCategories") cmbCategories: NgSelectComponent;
    @ViewChild("cmbDescriptions") cmbDescriptions: NgSelectComponent;
    @ViewChild("cmbGlitchStaff") cmbGlitchStaff: NgSelectComponent;
    @ViewChild("cmbGuestTemperaments") cmbGuestTemperaments: NgSelectComponent;

    @ViewChild("cmbGlitchStaffInvolved")
    cmbGlitchStaffInvolved: NgSelectComponent;
    @ViewChild("cmbTaggedStaff") cmbTaggedStaff: NgSelectComponent;

    @ViewChild("confirm") confirm;
    ConfirmModalRef: NgbModalRef;

    @ViewChild("confirmGuestRemoval") confirmGuestRemoval: ElementRef;
    ConfirmGuestResetModalRef: NgbModalRef;

    DateFormat: string;
    Model: Glitch_UpdateRequest;
    SaveModel: Glitch_UpdateRequest[] = [];
    SelectedGuests: any = [];
    _Glitch_RegistrationTypes = Glitch_RegistrationTypes;
    _GlitchOperationActions = GlitchOperationActions;
    _GlitchRegTypesMaster = this.GetRegistrationTypes();

    lstProperties: Array<PropertyBasicInfo> = [];

    lstLocations: Array<LocationLookup> = [];
    lstStaff: Array<GenericMaster> = [];
    lstDescriptions: Array<GlitchDescription> = [];
    AllDescriptions: Array<GlitchDescription> = [];
    lstCategories: Array<GlitchCategory> = [];
    lstAllGuest: Array<GuestLookup> = [];
    lstGuest: Array<GuestLookup> = [];
    lstGuestTemperaments: Array<GenericMaster> = [];
    VisitorSearchCharLimit = VisitorSearchCharLimit;
    ActiveTabs = new Collections.Dictionary<number, boolean>();
    tabID: number = 1;

    @Input() DisplayMode: number = 1;
    ShowQuickJob: boolean = true;

    // DEV-20345: on split-screen the Guest Details panel is shown as an in-view
    // overlay dialog (toggled by this flag) instead of an off-screen side
    // column. Kept inside this component's view so GuestDetail binds normally.
    showGuestDialog: boolean = false;

    openGuestDialog(): void {
        this.showGuestDialog = true;
        this.tabID = 2;
    }

    closeGuestDialog(): void {
        this.showGuestDialog = false;
    }

    ConfirmModel: any;

    MaxDate: Date = new Date();
    _JobPopoverMode = JobPopoverMode;
    _appSettings = AppSettings;

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected pmsService: PMSService,
        protected glitchService: GlitchService,
        private complainService: ComplainService,
        private modalService: NgbModal
    ) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        // DEV-20345: in split-screen / reduced width the quick-register bar
        // starts collapsed to just the lightning toggle; the user expands it
        // on demand. Full-screen (> 1024px) keeps the bar expanded.
        // NB: DisplayMode is always 2 for the embedded console bar, so the
        // split signal must be viewport width, not DisplayMode.
        if (typeof window !== 'undefined' && window.innerWidth <= 1024) {
            this.ShowQuickJob = false;
        }

        this.glitchService.InitiateEdit.pipe(untilDestroyed(this)).subscribe(
            row => {
                this.onInitiateEdit(row);
            }
        );

        this.glitchService.InitiateCopy.pipe(untilDestroyed(this)).subscribe(
            row => {
                this.onInitiateCopy(row);
            }
        );

        this.Model = new Glitch_UpdateRequest();

        this.SetModelDefaults();

        this.Model.GlitchRegistrationType = Glitch_RegistrationTypes.In_House_Guest;

        this.cmbLocations.virtualScroll = true;
        this.cmbCategories.virtualScroll = true;
        this.cmbDescriptions.virtualScroll = true;
        this.cmbGuests.virtualScroll = true;
        this.cmbGlitchStaff.virtualScroll = true;
        this.cmbGuestTemperaments.virtualScroll = true;

        this.cmbGlitchStaffInvolved.virtualScroll = true;
        this.cmbTaggedStaff.virtualScroll = true;

        this.lstProperties = this.masterService.GetProperties_Action(
            AuthActionCodes.GlitchRegistration
        );
        if (
            this.lstProperties.findIndex(
                a => a.PropertyId == this.masterService.ActivePropertyID
            ) > 0
        )
            this.Model.PropertyId = this.masterService.ActivePropertyID;
        else {
            if (this.lstProperties.length > 0)
                this.Model.PropertyId = this.lstProperties[0].PropertyId;
        }
        this.complainService.SelectedJob = null;
        this.glitchService.SelectedGlitch = null;
        this.SetMasters();
        this.CopyDataFromJob();
    }

    ngOnDestroy(): void {
        this.glitchService.SelectedGlitch = null;
    }

    SetModelDefaults(): void {
        this.Model.Operation = GlitchOperationActions.Register;
        this.Model.GlitchRegistrationType =
            Glitch_RegistrationTypes.In_House_Guest;
        this.Model.GlitchStaffId = null;
        this.Model.Details = null;
        this.Model.GuestTemperamentId = null;
        this.Model.GlitchIncedentDt = new Date();
        this.Model.IncidentLocationId = null;
        this.Model.DescriptionId = null;
        this.Model.TritonReservationId = null;
        this.Model.GlitchStaff = [];
        this.Model.TaggedStaff = [];
        this.Model.Attachments = [];
        this.Model.NoOfStays = null;
        this.Model.CheckInDate = null;
        this.Model.CheckOutDate = null;
        this.Model.LocationId = null;
        this.Model.RoomRate = null;
        this.Model.CategoryId = null;

        this.Model.GlitchGuestId = null;
        this.Model.Title = null;
        this.Model.FName = null;
        this.Model.LName = null;
        this.Model.FullName = null;
        this.Model.MobileNumber = null;
        this.Model.HomeNumber = null;
        this.Model.Address = null;
        this.Model.Email = null;

        this.SelectedGuests = [];
    }

    SetMasters(): void {

        this.DateFormat = this.masterService.GetPropertyDateFormat(this.Model.PropertyId);

        this.lstLocations = cloneDeep(
            this.masterService.GetLocations(this.Model.PropertyId)
        ); // JSON.parse(JSON.stringify(this.masterService.Cache_PropertyMainMasters.getValue(this.Model.PropertyId).Location));
        this.lstDescriptions = cloneDeep(
            this.masterService.GetGlitchDescritpion(this.Model.PropertyId)
        );
        this.lstDescriptions = this.lstDescriptions.filter(a => !a.IsDel);
        this.lstCategories = cloneDeep(
            this.masterService.GetGlitchCategories(this.Model.PropertyId)
        );
        this.lstCategories = alasql(
            "Select * From ? c Where c.Id In (Select Distinct d.CategoryId From ? d)",
            [this.lstCategories, this.lstDescriptions]
        );
        var allStaff = cloneDeep(
            this.masterService.GetStaff(this.Model.PropertyId)
        );
        this.lstStaff = allStaff.filter(x => {
            return x.Id !== 0;
        });

        this.AllDescriptions = cloneDeep(
            this.masterService.GetGlitchDescritpion(this.Model.PropertyId)
        );
        this.AllDescriptions = this.AllDescriptions.filter(a => !a.IsDel);
        this.lstAllGuest = this.pmsService.GetGuestLookup(
            this.Model.PropertyId
        );

        this.lstGuestTemperaments = this.masterService.GetGlitchTemperaments();

        //this.SetLocationData();

        // duration(ms) during which continuous updates will not be processed
        // this is prevent continuous guest updates (in large properties) to overwhelm page render
        const debounceDuration = 300;
        this.pmsService.GuestLookupChanged.pipe(
            untilDestroyed(this),
            debounceTime(debounceDuration)
        ).subscribe(PropertyId => {
            //console.info(this.pmsService.GetGuestLookup(PropertyId));
            if (this.Model.PropertyId == PropertyId) {
                this.lstAllGuest = JSON.parse(
                    JSON.stringify(this.pmsService.GetGuestLookup(PropertyId))
                );
                this.SetGuestData();
                //this.SetLocationData();
            }
        });

        this.SetGuestData();
    }

    GetRegistrationTypes() {
        return [
            {
                Id: Glitch_RegistrationTypes.PreArrival_Guest,
                Name: 'LBL.GLITCH_PREARRIVAL',
            },
            {
                Id: Glitch_RegistrationTypes.In_House_Guest,
                Name: 'LBL.GLITCH_INHOUSE',
            },
            {
                Id: Glitch_RegistrationTypes.CheckedOut_Guest,
                Name: 'LBL.GLITCH_CHECKEDOUT',
            },
            {
                Id: Glitch_RegistrationTypes.Visitor_Guest,
                Name: 'LBL.GLITCH_VISITOR',
            },
            {
                Id: Glitch_RegistrationTypes.Staff,
                Name: 'LBL.GLITCH_STAFF',
            }
        ]
    }


    onRegistrationTypeChange(newType: Glitch_RegistrationTypes): void {
        const oldType = this.Model.GlitchRegistrationType;
        //console.log('glitch-reg-type', newType, oldType);
        this.CheckForSelectedGuests()
            .then(result => {
                if (!result) {
                    this.Model.GlitchRegistrationType = null;
                    setTimeout(() => (this.Model.GlitchRegistrationType = oldType), 0);
                    return;
                }
                this.Model.GlitchRegistrationType = newType;
                this.Model.FullName = null;
                this.Model.GlitchGuestId = null;
                this.Model.GlitchStaffId = null;
                this.Model.TritonReservationId = null;
                this.SelectedGuests = [];
                this.onGuestChange(null);
                this.SetGuestData();
                })
    }

    CheckForSelectedGuests(): Promise<boolean> {
        if (!this.SelectedGuests || this.SelectedGuests.length <= 1) {
            return Promise.resolve(true);
        }
        let ngbModalOptions: NgbModalOptions = {
            backdrop: "static",
            size: "sm",
            centered: true
        };
        this.ConfirmGuestResetModalRef = this.modalService.open(
            this.confirmGuestRemoval,
            ngbModalOptions
        );
        return this.ConfirmGuestResetModalRef.result;
    }

    SetGuestData(): void {
        switch (this.Model.GlitchRegistrationType) {
            case Glitch_RegistrationTypes.CheckedOut_Guest:
            case Glitch_RegistrationTypes.Staff:
            case Glitch_RegistrationTypes.Visitor_Guest:
                this.lstGuest = [];
                break;
            case Glitch_RegistrationTypes.In_House_Guest:
                this.lstGuest = this.lstAllGuest.filter(
                    a => a.ReservationStatus == 2
                );
                break;
            case Glitch_RegistrationTypes.PreArrival_Guest:
                this.lstGuest = this.lstAllGuest.filter(
                    a => a.ReservationStatus == 1 || a.ReservationStatus == 6
                );
                break;
        }
        //.filter(x => x.ReservationStatus == 2)
    }

    onClear(): void {
        this.MaxDate = new Date();

        let propID = this.Model.PropertyId;
        this.Model = new Glitch_UpdateRequest();
        this.Model.PropertyId = propID;
        this.SetModelDefaults();
        //console.info(this.Model);
        this.SetMasters();
        this.ClearErrors();
        this.SaveModel = [];
        this.SelectedGuests = [];
        this.guest.GuestParams(null, null);
        this.complainService.SelectedJob = null;
        this.glitchService.SelectedGlitch = null;
    }

    onPropertyChange(): void {
        let propID = this.Model.PropertyId;
        this.Model = new Glitch_UpdateRequest();
        this.Model.PropertyId = propID;
        this.SetModelDefaults();

        //this.pmsService.GuestLookup_Get(this.Model.PropertyId).then(() => {
        //    this.SetDataFromJob();
        //});

        //this.SetMasters();
        this.onClear();
        this.SetDataFromJob();
    }

    DescriptionChanged(data: GlitchDescription): void {
        if (data == null) {
            return;
        }

        this.Model.CategoryId = data.CategoryId;
    }

    ShowTab(tabID: number): void {
        this.ActiveTabs.setValue(tabID, true);
        this.tabID = tabID;
    }

    HideTab(tabID: number): void {
        this.ActiveTabs.setValue(tabID, false);
        this.tabID = null;

        this.ActiveTabs.forEach((key, value) => {
            if (value == true) {
                this.tabID = key;
                return;
            }
        });
    }

    onCategoryChange(): void {
        let arr = new Array<GlitchDescription>();
        this.AllDescriptions.map((row, idx) => {
            if (this.Model.CategoryId == null) {
                arr.push(row);
            } else {
                if (row.CategoryId == this.Model.CategoryId) {
                    arr.push(row);
                }
            }
        });

        this.lstDescriptions = arr;

        this.Model.DescriptionId = null;
    }

    HandleLocationChange(): void {
    }

    onLocationChange(data: any): void {
        this.Model.LocationName = data.Description;
        this.HandleLocationChange();
    }

    onGuestLoaded(row: any): void { }

    onGuestChange(data: GuestLookup[]): void {
        this.complainService.SelectedJob = null;
        this.glitchService.SelectedGlitch = null;
        if (
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.Visitor_Guest ||
            data == null
        ) {
            this.HideTab(2);
            return;
        }

        if (!data) {
            return
        }

        const [firstGuest] = data.slice(0, 1);
        const [lastGuest] = data.slice(-1);

        if (lastGuest
            && this.CheckAuth_Dept_Action(this.Model.PropertyId, 0, this._AuthActionCodes.FrontOffice)
        ) {
            this.guest.GuestParams(lastGuest.GuestId, lastGuest.TritonReservationId);
            this.ShowTab(2);
        }

        if (!firstGuest || firstGuest.GuestId == undefined || firstGuest.GuestId == null) {
            return;
        }

        if (this.Model.IncidentLocationId != null) return;

        this.Model.IncidentLocationId = firstGuest.LocationId;

        if (this.Model.GlitchRegistrationType == Glitch_RegistrationTypes.CheckedOut_Guest) {
            this.Model.LocationName = firstGuest.FullName;
        }

        this.Model.FullName = firstGuest.FullName;

        this.HandleLocationChange();
    }

    private GetUpdateRequestsFromGuests(model = this.Model, selectedGuests = this.SelectedGuests): Glitch_UpdateRequest[] {
        return (selectedGuests || []).map(guest => {
            const result = Object.assign(new Glitch_UpdateRequest(), cloneDeep(model || {}));
            result.GlitchGuestId = guest.GuestId;
            result.TritonReservationId = guest.TritonReservationId;
            result.FullName = guest.FullName;
            result.LocationName = guest.LocationId == result.IncidentLocationId
                ? guest.FullName
                : this.masterService.MasterData_GetMutli(result.PropertyId, result.IncidentLocationId, EntityCodes.Location, null);

            return result
        });
    }

    Validate(): void {
        let cDate = new Date();

        if (
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.CheckedOut_Guest ||
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.In_House_Guest ||
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.PreArrival_Guest
        ) {
            if (!this.SelectedGuests.length || !every(this.SelectedGuests, (guest) => guest.GuestId)) {
                this.AddError("ERR.ERR_SELECT_GUEST_FOR_GUEST_GLITCH");
            }
        }
        if (
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.Visitor_Guest
        ) {
            if (
                this.Model.FName == null ||
                this.Model.FName.trim().length == 0
            ) {
                this.AddError("ERR.ERR_GLITCH_VISITOR_FIRSTNAME");
            }

            if (
                this.Model.LName == null ||
                this.Model.LName.trim().length == 0
            ) {
                this.AddError("ERR.ERR_GLITCH_VISITOR_LASTNAME");
            }

            if (
                (this.Model.HomeNumber == null ||
                    this.Model.HomeNumber.trim().length == 0) &&
                (this.Model.MobileNumber == null ||
                    this.Model.MobileNumber.trim().length == 0) &&
                (this.Model.Email == null ||
                    this.Model.Email.trim().length == 0)
            ) {
                this.AddError("ERR.ERR_GLITCH_VISITOR_ONECONTACT");
            }
            let regexEmail = /^([a-zA-Z0-9_.+-])+[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})$/;

            if (
                this.Model.Email != null &&
                this.Model.Email.trim().length != 0 &&
                !regexEmail.test(this.Model.Email)
            ) {
                this.AddError("ERR.ERR_ENTER_VALID_EMAIL");
            }

            if (
                this.Model.HomeNumber != null &&
                this.Model.HomeNumber.trim().length != 0 &&
                !this.Model.HomeNumber.match(/^[0-9]+$/)
            ) {
                this.AddError("ERR.ERR_ENTER_VALID_PHONE_NO");
            }

            if (
                this.Model.MobileNumber != null &&
                this.Model.MobileNumber.trim().length != 0 &&
                !this.Model.MobileNumber.match(/^[0-9]+$/)
            ) {
                this.AddError("ERR.ERR_ENTER_VALID_MOBILE_NO");
            }
        }
        if (
            this.Model.GlitchRegistrationType == Glitch_RegistrationTypes.Staff
        ) {
            if (this.Model.GlitchStaffId == null) {
                this.AddError("ERR.ERR_GLITCH_SELECT_STAFF");
            }
        }
        if (this.Model.IncidentLocationId == null) {
            this.AddError("ERR.ERR_SELECT_LOCATION");
        }

        if (this.Model.GlitchIncedentDt == null) {
            this.AddError("ERR.ERR_INCIDENTDATE_REQUIRED");
        }

        if (
            this.Model.GlitchIncedentDt != null &&
            this.Model.GlitchIncedentDt > cDate
        ) {
            this.AddError("ERR.ERR_INCIDENTDATE_GREATERNOW");
        }

        if (
            this.Model.GlitchIncedentDt != null &&
            this.Model.OriginalLoggedDate != null &&
            this.Model.Operation == GlitchOperationActions.Edit &&
            this.Model.GlitchIncedentDt > this.Model.OriginalLoggedDate
        ) {
            this.AddError("ERR.ERR_INCIDENTDATE_GREATER_LOGGEDDATE");
        }

        if (this.Model.DescriptionId == null) {
            this.AddError("ERR.ERR_SELECT_DESCR");
        }

        // max glitches limit check
        const preGlitchesCount = (this.SaveModel || []).length;

        const modelGlitchesCount = (
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.CheckedOut_Guest ||
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.In_House_Guest ||
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.PreArrival_Guest
        ) ? (this.SelectedGuests || []).length : 1

        if ((preGlitchesCount + modelGlitchesCount) > AppSettings.MAX_GLITCHES) {
            this.AddError("ERR.ERR_MAX_GLITCHES_EXCEED");
        }

        this.ValidateDuplicatesInSaveModel();

    }

    ValidateAttachmentSize(): void {
        let size_Attach = 0;

        if (
            this.Model.Attachments != null &&
            this.Model.Attachments.length > 0
        ) {
            this.Model.Attachments.forEach(rowAttach => {
                if (rowAttach != null && rowAttach.Base64String != null)
                    size_Attach += rowAttach.Base64String.length;
            });
        }

        if (size_Attach > AppSettings.MAX_UPLOAD_SIZE) {
            let errorText = this.translate.instant("ERR.ERR_ATTACHMENT_SIZE");
            this.AddError(
                errorText + " " + AppSettings.MaxUploadSize_MB() + " MB"
            );
        }
    }

    UpdateErrors

    FormSubmit(): void {
        if (this.IsSubmitting) return;

        this.SubmitStart();

        this.ClearErrors();

        const arr: Glitch_UpdateRequest[] = this.SaveModel.length > 0
            ? cloneDeep(this.SaveModel)
            : [];

        if (arr.length === 0) {
            this.Validate();

            if (!this.HasErrors) {
                if (this.Model.Operation == this._GlitchOperationActions.Edit) {
                    this.Model.Attachments = null;
                }

                if (
                    this.Model.GlitchRegistrationType ==
                    Glitch_RegistrationTypes.Staff
                ) {
                    this.Model.GlitchGuestId = null;
                    this.Model.TritonReservationId = null;
                    arr.push(this.Model)
                } else if(this.Model.GlitchRegistrationType ==
                    Glitch_RegistrationTypes.Visitor_Guest) {
                        this.Model.TritonReservationId = null;
                        arr.push(this.Model)
                } else {
                    const guestGlitches = this.GetUpdateRequestsFromGuests();
                    arr.splice(-1, 0, ...guestGlitches)
                }
            }
        }

        if (this.HasErrors) {
            if (this.DisplayMode == 2) {
                this.ShowErrorInPopup();
            }

            this.SubmitEnd();
            if (this.DisplayMode == 3)
                document.getElementById("registerPage").scrollTop = 0;
            return;
        }

        this.glitchService.Glitch_RegisterMultiple(arr).then(data => {
            this.SubmitEnd();
            this.FromBaseResponse(data);

            if (this.HasErrors) {
                if (this.DisplayMode == 3) {
                    document.getElementById("registerPage").scrollTop = 0;
                }

                if (this.DisplayMode == 2) {
                    this.ShowErrorInPopup();
                }

            } else {
                if (this.Model.Operation == GlitchOperationActions.Edit) {
                    this.glitchService.TriggerRequireFullRefresh();
                    this.DisplayMode = 2;
                    this.GetMultilingualToast(
                        "TS.TS_GLITCH_UPDATE_SUCCESS",
                        "success"
                    );
                } else {
                    if (this.DisplayMode == 2)
                        this.glitchService.TriggerRequireFullRefresh();
                    this.ConfirmModel = data.Result;
                    this.GetMultilingualToast(
                        "TS.TS_GLITCH_REGISTER_SUCCESS",
                        "success"
                    );
                    let ngbModalOptions: NgbModalOptions = {
                        backdrop: "static",
                        size: "lg"
                    };
                    this.ConfirmModalRef = this.modalService.open(
                        this.confirm,
                        ngbModalOptions
                    );
                }

                this.onClear();
            }
        });
    }

    private setPureLocation(model: Glitch_UpdateRequest): Glitch_UpdateRequest {
        if (model.GlitchRegistrationType == Glitch_RegistrationTypes.Visitor_Guest
            || model.GlitchRegistrationType === Glitch_RegistrationTypes.Staff) {
            model.LocationName = this.masterService.MasterData_GetMutli(model.PropertyId, model.IncidentLocationId, EntityCodes.Location, null);
        }

        return model;
    }

    AddMultiple(): void {

        this.ClearErrors();

        this.Validate();

        this.ValidateAttachmentSize();

        if (this.HasErrors) {
            return;
        }

        const modelGlitches = (
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.CheckedOut_Guest ||
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.In_House_Guest ||
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.PreArrival_Guest
        )
            ? this.GetUpdateRequestsFromGuests()
            : [cloneDeep(this.setPureLocation(this.Model))];

        const firstGlitch = first(modelGlitches);

        const sourceGlitch = this.SelectedGuests.length
            ? ((this.SelectedGuests.length == 1) ? firstGlitch : null)
            : firstGlitch;

        const transformed = modelGlitches.map(req => {
            req["GlitchDescription"] = this.masterService.MasterData_GetMutli(
                req.PropertyId,
                req.DescriptionId,
                EntityCodes.GlitchDescriptionMaster,
                ""
            );

            req["GlitchTemperamentName"] = this.masterService.MasterData_GetMutli(
                req.PropertyId,
                req.GuestTemperamentId,
                EntityCodes.GuestTemperamentMaster,
                ""
            );

            req["GlitchRegistrationTypeName"] = this.masterService.MasterData_GetMutli(
                req.PropertyId,
                req.GlitchRegistrationType,
                EntityCodes.GlitchRegistrationTypes, "");

            req["GlitchStaffName"] = this.masterService.MasterData_GetMutli(
                req.PropertyId,
                req.GlitchStaffId,
                EntityCodes.Staff, "");

            if (this.Model.GlitchRegistrationType == Glitch_RegistrationTypes.Visitor_Guest) {
                req.FullName = `${req.Title ? req.Title + ' ': ''}${req.FName} ${req.LName}`
            }

            return req;
        });

        this.SaveModel = this.SaveModel.concat(transformed);

        const glitchGuestType = this.Model.GlitchRegistrationType;

        this.SetModelDefaults();

        this.Model.GlitchRegistrationType = glitchGuestType;

        this.SetMasters();

        this.loadGlitchSource(glitchGuestType, sourceGlitch);

        this.ShowTab(3);

    }

    /**
     * Populates `this.Model` with data from a source glitch depending
     * on registration type
     * @param glitchType
     * @param glitch
     */
    private loadGlitchSource(glitchType: Glitch_RegistrationTypes, glitch: Glitch_UpdateRequest) {
        if (!glitch) {
            return;
        }

        this.Model.PropertyId = glitch.PropertyId;
        this.Model.IncidentLocationId = glitch.IncidentLocationId;

        switch (glitchType) {
            case Glitch_RegistrationTypes.PreArrival_Guest:
            case Glitch_RegistrationTypes.In_House_Guest:
            case Glitch_RegistrationTypes.CheckedOut_Guest:
                const guest = new GuestLookup();
                guest.GuestId = glitch.GlitchGuestId;
                guest.TritonReservationId = glitch.TritonReservationId;
                guest.FullName = glitch.FullName;
                guest.LocationId = glitch.FullName == glitch.LocationName ? glitch.IncidentLocationId : null;

                this.SelectedGuests = [guest];
                this.Model.GlitchGuestId = glitch.GlitchGuestId;
                this.Model.TritonReservationId = glitch.TritonReservationId;
                this.Model.FullName = glitch.FullName;

                break;

            case Glitch_RegistrationTypes.Staff:
                this.Model.GlitchStaffId = glitch.GlitchStaffId;
                break;

            case Glitch_RegistrationTypes.Visitor_Guest:

                this.Model.Title = glitch.Title;
                this.Model.FName = glitch.FName;
                this.Model.LName = glitch.LName;

                this.Model.Email = glitch.Email;
                this.Model.MobileNumber = glitch.MobileNumber;
                this.Model.HomeNumber = glitch.HomeNumber;
                this.Model.Address = glitch.Address
                break;
        }
    }

    ValidateDuplicatesInSaveModel() {
        if (!this.Model.DescriptionId || !this.Model.IncidentLocationId) {
            return;
        }

        if (!this.SaveModel.length) {
            return;
        }
        // condition 1 - find glitches with same desc as model
        // condition 2 - find glitches at same location too
        // condition 3 - find glitches for same person too
        const similarGlitches = this.SaveModel.filter(
            req => req.DescriptionId === this.Model.DescriptionId
                && req.IncidentLocationId === this.Model.IncidentLocationId
                && req.GlitchRegistrationType === this.Model.GlitchRegistrationType
        );


        switch (this.Model.GlitchRegistrationType) {
            case Glitch_RegistrationTypes.Staff:
                const staffIds = similarGlitches.map(req => req.GlitchStaffId);
                if (staffIds.indexOf(this.Model.GlitchStaffId) >= 0) {
                    this.AddError('ERR.ERR_GLITCH_DUPLICATE')
                    return;
                }
                break;
            case Glitch_RegistrationTypes.Visitor_Guest:
                const nameJoiner = (req: Glitch_UpdateRequest) => [req.FName, req.LName].join(' ');
                const visitors = similarGlitches.map(nameJoiner);
                if (visitors.indexOf(nameJoiner(this.Model)) >= 0) {
                    this.AddError('ERR.ERR_GLITCH_DUPLICATE')
                    return;
                }
                break;
            case Glitch_RegistrationTypes.PreArrival_Guest:
            case Glitch_RegistrationTypes.In_House_Guest:
            case Glitch_RegistrationTypes.CheckedOut_Guest:
                const guests = similarGlitches.map(req => req.GlitchGuestId);
                const selected = this.SelectedGuests.map(guest => guest.GuestId);
                const common = intersection(guests, selected);
                if (common.length) {
                    this.AddError('ERR.ERR_GLITCH_DUPLICATE')
                    return;
                }
                break;
        }
    }

    onGlitchDelete(row) {
        if (!row) {
            return;
        }

        remove(this.SaveModel, row);

        if (this.SaveModel.length == 0) {
            this.tabID = 1;
        }
    }

    onAttachmentChanged(data: Array<GlitchAttachment>): void {
        this.Model.Attachments = data;
    }

    onGuestSelected(row: GuestLookup): void {
        if (
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.CheckedOut_Guest
        ) {
            if (row != null) {
                // location description from guest search doesnt have location appended to guest name,
                // which in multi-glitch table shows as guest name (as incident-loc-id and guest location id are same)

                row.FullName = row.FullName.indexOf(row.LocationDescription) >= 0
                    ? row.FullName
                    : `${row.LocationDescription} - ${row.FullName}`;

                this.Model.FullName = row.FullName;
                this.Model.GlitchGuestId = row.GuestId;
                this.Model.TritonReservationId = row.TritonReservationId;
                this.SelectedGuests = [row];
                this.onGuestChange(this.SelectedGuests);
            } else {
                this.Model.FullName = null;
                this.Model.GlitchGuestId = null;
                this.Model.TritonReservationId = null;
            }
        }
    }

        onVisitorSelected(row: VisitorLookup): void {
        if (
            this.Model.GlitchRegistrationType ==
            Glitch_RegistrationTypes.Visitor_Guest
        ) {
            if (row != null) {
                this.Model.FName = row.FName;
                this.Model.Title = row.Title;
                this.Model.LName = row.LName;
                this.Model.MobileNumber = row.ContactNumber;
                this.Model.Email = row.EmailId;
                this.Model.GlitchGuestId = row.Id;
                this.SelectedGuests = [row];
                 let RequestModel: any;
                    RequestModel = {
                        GuestId: row.Id,
                        TritonReservationId: this.Model.TritonReservationId,
                        SendReservations : true,
                        PageNumber: 1,
                        PageSize: 25
                }
            this.guest.GuestParams(row.Id, this.Model.TritonReservationId, true);
            this.ShowTab(2);
            }
        }
    }

    onInitiateEdit(row: Glitch_UpdateRequest): void {
        this.ClearErrors();
        this.OpenEdit(row);
    }

    OpenEdit(row: Glitch_UpdateRequest): void {
        this.MaxDate = row.OriginalLoggedDate;

        this.DisplayMode = 3;

        this.Model = row;

        this.SetMasters();
        let rg = new GuestLookup();
        rg.GuestId = row.GlitchGuestId;
        rg.TritonReservationId = row.TritonReservationId;
        rg.PropertyId = row.PropertyId;
        this.SelectedGuests = [rg];
        this.onGuestChange(this.SelectedGuests);
    }

    onInitiateCopy(row: Glitch_UpdateRequest): void {
        this.ClearErrors();
        this.OpenCopy(row);
    }

    OpenCopy(row: Glitch_UpdateRequest): void {
        this.MaxDate = row.OriginalLoggedDate;

        this.DisplayMode = 3;

        this.Model = row;
    }

    CopyDataFromJob(): void {
        if (
            this.masterService.TransferModel == undefined ||
            this.masterService.TransferModel == null ||
            this.Model == null ||
            this.Model == undefined
        )
            return;

        this.Model.PropertyId = this.masterService.TransferModel.PropertyId;
        this.onPropertyChange();
    }

    SetDataFromJob(): void {
        if (
            this.masterService.TransferModel == undefined ||
            this.masterService.TransferModel == null
        )
            return;

        if (
            this.lstLocations.findIndex(
                x => x.Id == this.masterService.TransferModel.IncidentLocationId
            ) != -1
        )
            this.Model.IncidentLocationId = this.masterService.TransferModel.IncidentLocationId;

        this.Model.DescriptionId = this.masterService.TransferModel.DescriptionId;

        if (this.Model.DescriptionId != null) {
            let categoryIndex = this.lstDescriptions.findIndex(
                x => x.Id == this.Model.DescriptionId
            );
            if (categoryIndex != -1)
                this.Model.CategoryId = this.lstDescriptions[
                    categoryIndex
                ].CategoryId;
        } else {
            this.GetMultilingualToast(
                "TS.TS_GLITCH_DESCRIPTION_ERROR",
                "error"
            );
        }

        let rowGuest = null;
        let rowStaff = null;

        if (this.masterService.TransferModel.GlitchGuestId != null) {
            rowGuest = this.lstAllGuest.find(
                x => x.GuestId == this.masterService.TransferModel.GlitchGuestId
            );

            if (rowGuest != null) {
                this.Model.GlitchRegistrationType =
                    Glitch_RegistrationTypes.In_House_Guest;
                this.Model.GlitchGuestId = this.masterService.TransferModel.GlitchGuestId;
            }
        }

        if (
            rowGuest == null &&
            this.masterService.TransferModel.GlitchStaffId != null
        ) {
            rowStaff = this.lstStaff.find(
                x => x.Id == this.masterService.TransferModel.GlitchStaffId
            );
            if (rowStaff != null) {
                this.Model.GlitchStaffId = this.masterService.TransferModel.GlitchStaffId;
                this.Model.GlitchRegistrationType =
                    Glitch_RegistrationTypes.Staff;
            }
        }

        if (rowStaff == null && rowGuest == null) {
            if (this.masterService.TransferModel.GlitchGuestId != null) {
                this.Model.GlitchRegistrationType =
                    Glitch_RegistrationTypes.CheckedOut_Guest;
            } else {
                this.Model.GlitchRegistrationType =
                    Glitch_RegistrationTypes.Staff;
            }
        }

        this.masterService.TransferModel = null;
        if (rowGuest != null) {
            this.SelectedGuests = [rowGuest];
            this.onGuestChange(this.SelectedGuests);
        }
    }

}
